var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ConfigDetail from "./ConfigDetail.vue";
import PurchaseTime from "./PurchaseTime.vue";
import Decoration from "./Decoration.vue";
import MiniProgramConfig from "./MiniProgramConfig.vue";
var ManageList = (function (_super) {
    __extends(ManageList, _super);
    function ManageList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = '0';
        _this.shoppingDetail = {};
        return _this;
    }
    ManageList.prototype.created = function () {
    };
    ManageList.prototype.mounted = function () {
    };
    ManageList.prototype.getShoppingDetail = function (data) {
        this.shoppingDetail = JSON.parse(JSON.stringify(data));
    };
    ManageList = __decorate([
        Component({
            components: {
                MiniProgramConfig: MiniProgramConfig,
                'config-detail': ConfigDetail,
                'purchase-time': PurchaseTime,
                'decoration': Decoration,
            }
        })
    ], ManageList);
    return ManageList;
}(Vue));
export default ManageList;
